// client/src/api/inventario.js
import api from "./config.js";

// Obtener todo el inventario
export const getInventarios = async () => {
  const { data } = await api.get("/inventario");
  return data;
};

// Obtener inventario por ID
export const getInventario = async (id) => {
  const { data } = await api.get(`/inventario/${id}`);
  return data;
};

// Crear inventario
export const createInventario = async (inventario) => {
  const { data } = await api.post("/inventario", inventario);
  return data;
};

// Actualizar inventario
export const updateInventario = async (id, inventario) => {
  const { data } = await api.put(`/inventario/${id}`, inventario);
  return data;
};

// Eliminar inventario
export const deleteInventario = async (id) => {
  const { data } = await api.delete(`/inventario/${id}`);
  return data;
};
